/**
 * Whether a route is scoped to a single branch (vs system/user-wide).
 *
 * Branch-scoped pages show the BranchSelector and surface their title via the
 * mobile PageIndicatorPill. System/user pages (portfolio overview, admin
 * device/user management, account settings) hide the selector and instead show
 * their title inline in the mobile top bar.
 *
 * Shared between Header (selector + in-bar title) and Layout (pill) so the two
 * never disagree about which kind of page is showing.
 */
export function isBranchScopedPath(path: string): boolean {
  return (
    path !== '/usage/portfolio'
    && !path.startsWith('/admin/')
    && path !== '/admin'
    && !path.startsWith('/settings')
  );
}
